export const EXSBINVOICESTATUS_CREATE_RESET = 'EXSBINVOICESTATUS_CREATE_RESET'
export const EXSBINVOICESTATUS_CREATE_SET_CREATED = 'EXSBINVOICESTATUS_CREATE_SET_CREATED'
export const EXSBINVOICESTATUS_CREATE_SET_ERROR = 'EXSBINVOICESTATUS_CREATE_SET_ERROR'
export const EXSBINVOICESTATUS_CREATE_SET_VIOLATIONS = 'EXSBINVOICESTATUS_CREATE_SET_VIOLATIONS'
export const EXSBINVOICESTATUS_CREATE_TOGGLE_LOADING = 'EXSBINVOICESTATUS_CREATE_TOGGLE_LOADING'
